module.exports = __webpack_public_path__ + "static/media/karachi-dark.9a569e31.svg";